import React, { memo } from 'react';
import { useSurveyConfig } from 'app/core/survey-config';
import { useItemSortAnswer } from './hooks';
import Clear from './Clear';
import Unselected from './Unselected';
import Selected from './Selected';
import { useStyles } from './styles';

function Answer() {
  const {
    count,
    unselected,
    selected,
    onSortEnd,
    onSelect,
    onRemove,
    onClear
  } = useItemSortAnswer();
  const disabled = selected.length >= count;
  const { wording } = useSurveyConfig();
  const styles = useStyles();

  return (
    <>
      <Clear label={wording.subject.itemsort.resort} onClear={onClear} />
      <div className={styles.container}>
        <Unselected
          label={wording.subject.itemsort.dargit}
          disabled={disabled}
          options={unselected}
          onSelect={onSelect}
        />
        <Selected
          label={wording.subject.itemsort.sortit}
          options={selected}
          onRemove={onRemove}
          onSortEnd={onSortEnd}
        />
      </div>
    </>
  );
}

export default memo(Answer);
